import { PropsWithChildren, useEffect, useState } from "react";
import Button from "./Button/Button";
import Input from "./Forms/Input";
import Modal from "./Modal/Modal";

type ConfirmationModalProps = PropsWithChildren<{
    open?: boolean,
    onCancel: () => void,
    onConfirm: () => void,
    // when set, Confirm stays disabled until the user types this exact phrase - for higher-severity deletions
    requireTypedConfirmation?: string,
}>

function ConfirmationModal({open = false, onCancel, onConfirm, requireTypedConfirmation, children}: ConfirmationModalProps) {
    const [typedConfirmation, setTypedConfirmation] = useState('');

    // reset so a stale value can't silently satisfy the check next time the modal opens
    useEffect(() => {
        if (!open) {
            setTypedConfirmation('');
        }
    }, [open]);

    const confirmDisabled = !!requireTypedConfirmation && typedConfirmation !== requireTypedConfirmation;

    return (
        <Modal open={open} onClose={onCancel} size="small"  >
            <div>
                { children }
            </div>
            { requireTypedConfirmation && (
                <Input
                    type="text"
                    name="typedConfirmation"
                    label={<>To confirm type <em>{requireTypedConfirmation}</em> in the field</>}
                    placeholder={requireTypedConfirmation}
                    additionalClass="mt-4"
                    value={typedConfirmation}
                    onChange={e => setTypedConfirmation(e.target.value)}
                />
            )}
            <div className="flex space-x-2 mt-4">
                <Button type="Primary" text="Confirm" onClick={onConfirm} disabled={confirmDisabled} />
                <Button type="Outlined" text="Cancel" onClick={onCancel} />
            </div>
        </Modal>
    )
}

export default ConfirmationModal;
